module.exports = __webpack_public_path__ + "static/media/heart-red.89a24354.svg";